import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const Loading = ({ mods={}, color }) => {
    const { className } = useMods(Loading, { mods: { ...mods, color } });

    return (
        <div
            className={ className }
        >
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

Loading.displayName = 'Loading';

Loading.propTypes = {
    mods: PropTypes.object
};

export default Loading;
